import { useEffect, useRef, useState } from "react";
import clsx from "clsx";

export default function Dropdown({ button, content, className, autoClose = true }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleItemClick = () => {
    if (autoClose) setIsOpen(false);
  };

  return (
    <div className={clsx("relative", className)} ref={dropdownRef}>
      <div onClick={toggleDropdown}>{button}</div>

      <div className="absolute left-1/2 transform -translate-x-1/2 pt-7">
        <Menu isOpen={isOpen} onItemClick={handleItemClick}>
          {content}
        </Menu>
      </div>
    </div>
  );
}

function Menu({ children, isOpen, onItemClick }) {
  return (
    <div
      className={clsx(
        "absolute left-1/2 top-3 transform -translate-x-1/2 z-20", // always positioned
        "bg-white rounded-2xl shadow-[0_4px_12px_rgba(0,0,0,0.09)]",
        "transition-all duration-200 ease-in-out",
        isOpen
          ? "opacity-100 translate-y-2 pointer-events-auto visible"
          : "opacity-0 -translate-y-1 pointer-events-none invisible"
      )}
      onClick={onItemClick}
    >
      {children}
    </div>
  );
}